/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MandateEventKindId } from './mandateEventKindId';
import type { MandateEventKindLabel } from './mandateEventKindLabel';
import type { MandatePlanningStatus } from './mandatePlanningStatus';
import type { MandatePlanningReason } from './mandatePlanningReason';
import type { MandateMissingCount } from './mandateMissingCount';
import type { MandateSegments } from './mandateSegments';

/**
 * A clear definition of what a specific lecturer is responsible for.

Derived dynamically from Module/Course responsibilities and Tenant EventKind settings.
 */
export interface Mandate {
  moduleId: string;
  moduleTitle: string;
  roleTitle: string;
  eventKindId?: MandateEventKindId;
  eventKindLabel?: MandateEventKindLabel;
  planningStatus?: MandatePlanningStatus;
  planningReason?: MandatePlanningReason;
  missingCount?: MandateMissingCount;
  segments?: MandateSegments;
}
